const RepairFileEndStatusConstant = {
  PRODUCT_REPAIRED: 'PRODUCT_REPAIRED',
  PRODUCT_REPLACED_STANDARD: 'PRODUCT_REPLACED_STANDARD',
  PRODUCT_REPLACED_SUPERIOR: 'PRODUCT_REPLACED_SUPERIOR',
  PRODUCT_CREDIT: 'PRODUCT_CREDIT',
  PRODUCT_RECYCLED: 'PRODUCT_RECYCLED',
  PRODUCT_RETURN_DISASSEMBLED: 'PRODUCT_RETURN_DISASSEMBLED'
}

export default RepairFileEndStatusConstant
